__turbopack_context__.v({
  "canvas": "PresentationStage-module__A8PofG__canvas",
  "controls": "PresentationStage-module__A8PofG__controls",
  "hint": "PresentationStage-module__A8PofG__hint",
  "poster": "PresentationStage-module__A8PofG__poster",
  "stage": "PresentationStage-module__A8PofG__stage",
  "surface": "PresentationStage-module__A8PofG__surface",
});
